import { Schemas } from '~/api/gen'
import { Img } from '~/components/elements/Img'

type Props = {
  coordinateFolders: Schemas.folder_summary[]
}

const RelationFolder: React.FC<{
  folder: Schemas.folder_summary
}> = ({ folder }) => (
  <a
    className="relative flex overflow-hidden rounded-[10px] shadow-folder-item"
    href={`/${folder.member.user_name}/favorite/${folder.id}/`}
  >
    <Img src={folder.image?.url_215 ?? ''} width={140} height={186} alt="" />
    <p className="absolute left-0 top-0 flex size-full items-center justify-center px-5 text-center text-[16px] font-bold leading-[1.6] text-white text-shadow-[0_0_20px_rgb(0,0,0,0.8)]">
      {folder.name}
    </p>
  </a>
)

export const RelationFolders: React.FC<Props> = ({ coordinateFolders }) => (
  <>
    <h2 className="px-4 text-sm font-bold leading-[1.4]">関連フォルダ</h2>
    <div className="overflow-scroll pb-[18px] pt-[13px]">
      <ul className="flex pl-4">
        {coordinateFolders.map((folder) => (
          <li key={folder.id} className="shrink-0 pr-4">
            <RelationFolder folder={folder} />
          </li>
        ))}
      </ul>
    </div>
  </>
)
